import { isUndefined } from 'lodash'
import { isWantAction } from '../helpers'
import {
  I_WANT_LOADING,
  I_WANT_FAILURE,
  I_WANT_SUCCESS,
  I_WANT_NOT_LOADING,
  I_WANT_NOT_FAILURE,
  I_WANT_NOT_SUCCESS,
} from '../../actions'

const wantedLoadingReducer = (prevState = {}, { type, payload }) => {
  switch (type) {
    case I_WANT_LOADING:
    case I_WANT_NOT_LOADING:
      return {
        ...prevState,
        [payload]: true,
      }
    case I_WANT_SUCCESS:
    case I_WANT_FAILURE:
    case I_WANT_NOT_SUCCESS:
    case I_WANT_NOT_FAILURE:
      return {
        ...prevState,
        [payload]: false,
      }
    default:
      return prevState
  }
}

const itemsWantedReducer = (prevState = { wantedLoadingById: {} }, action) => {
  if (isWantAction(action) && !isUndefined(prevState.data[action.payload])) {
    return {
      ...prevState,
      wantedLoadingById: wantedLoadingReducer(
        prevState.wantedLoadingById,
        action
      ),
    }
  }
  return prevState
}

export default itemsWantedReducer



// WEBPACK FOOTER //
// ./src/reducers/items/wanted.js